module.exports = __webpack_public_path__ + "fonts/e65ae7e.ttf";